<template>
  <div class="gx-agreement">
    <stars-canvas :count="75" :meteor-max="1" :meteor-gap="1100" fixed />
    <float-pts :count="10" fixed />
    <div class="gx-agreement__orb gx-agreement__orb--left"></div>
    <div class="gx-agreement__orb gx-agreement__orb--right"></div>

    <new-ui-nav
      :is-logged-in="isLoggedIn"
      compact-auth
      @home="goHome"
      @login="goLogin"
      @register="goRegister"
      @enter="goEnter"
    />

    <main class="gx-agreement__content">
      <header class="gx-agreement__hero">
        <div class="gx-agreement__eyebrow">STAR TREE · USER AGREEMENT</div>
        <h1>观星树用户协议</h1>
        <p>请您在注册、登录或使用观星树服务前，认真阅读并充分理解本协议。</p>
        <div class="gx-agreement__meta">
          <span>版本号：V1.0</span>
          <span>生效时间：2026-09-15 09:00:00</span>
        </div>
      </header>

      <article class="gx-agreement__paper">
        <section class="gx-agreement__notice">
          <h2>特别提示</h2>
          <p>本《观星树用户协议》（以下简称“本协议”）由您与星观（杭州）数据科技有限公司（以下简称“本公司”或“观星树”）就使用观星树平台及相关服务所订立。您通过网络页面点击确认、完成注册、登录、实际使用服务或以其他方式表示接受本协议的，即视为您已充分阅读、理解并同意受本协议约束。</p>
          <p>如您不同意本协议的任何内容，请立即停止注册、登录或使用观星树服务。您应为具备完全民事行为能力的自然人，或依法设立并有效存续的组织；如您代表组织使用服务，您确认已获得该组织的充分授权。</p>
        </section>

        <section>
          <h2>一、定义与适用范围</h2>
          <p>1. 观星树服务，是指观星树通过网站、软件、客户端及其他载体向商家提供的 AI 智能店群运营相关产品与服务，包括但不限于店铺运营辅助、商品与内容处理、数据分析、任务管理、合规检测及本公司后续依法上线的功能。</p>
          <p>2. 用户，是指注册、登录、浏览、访问或使用观星树服务的个人、企业或其他组织。商家，是指使用服务开展经营活动或管理其店铺、商品、订单及相关业务的用户。</p>
          <p>3. 本协议适用于观星树向您提供的全部服务。针对特定产品、付费服务、活动或第三方能力另有规则、订单、授权书或补充协议的，相关文件与本协议共同构成双方协议；约定不一致的，以该特定文件为准。</p>
        </section>

        <section>
          <h2>二、账号注册、使用与安全</h2>
          <p>1. 您应提供真实、准确、完整且持续有效的注册信息，并及时更新发生变化的信息。您不得以虚假信息、他人信息或其他不当方式注册、认证或使用账号。</p>
          <p>2. 账号仅限您本人或经您合法授权的员工使用。您应妥善保管账号、密码、验证码、授权凭证及设备，不得出租、出借、出售、转让、共享或以其他方式允许无关第三方使用。</p>
          <p>3. 因您保管不善、授权不当、密码泄露、设备丢失或未及时通知本公司造成的损失，由您自行承担。发现账号被盗、异常登录或其他安全风险时，您应立即通过平台公布的方式通知本公司，并配合采取必要措施。</p>
          <p>4. 为保障交易与账号安全，本公司可依法律法规、监管要求或风险控制需要，要求您进行身份、资质、店铺主体或授权关系核验；您拒绝配合或核验未通过的，本公司有权限制相关服务。</p>
        </section>

        <section>
          <h2>三、服务内容、开通与变更</h2>
          <p>1. 本公司将依现有技术能力和平台规则提供服务，并持续优化产品。具体功能、适用范围、服务期限、可用额度和收费标准，以订购页面、产品说明、订单或双方另行确认的内容为准。</p>
          <p>2. 您理解并同意，AI 生成、分析、推荐、检测或自动化处理结果仅作为运营辅助和参考，不构成对经营结果、平台审核结果、商品合规性、知识产权状态、销量、收益或其他任何结果的承诺或保证。您应结合实际业务情况自行审核、判断并承担最终决策责任。</p>
          <p>3. 本公司可能基于业务发展、法律法规、技术升级或安全需要，对服务功能、交付方式、展示形式、规则或入口进行更新、调整、中止或终止，并依法或按合理方式向您通知。除法律另有规定或双方另有约定外，本公司不因此对您承担额外赔偿责任。</p>
        </section>

        <section>
          <h2>四、店铺及第三方平台授权</h2>
          <p>1. 当您连接、授权或管理第三方电商平台、店铺、账号或其他服务时，您保证对该等账号、店铺、数据及授权操作拥有合法、充分且持续有效的权利，并已取得必要的主体、员工、合作方及第三方同意。</p>
          <p>2. 您应自行遵守第三方平台的服务协议、规则、政策、数据规范及法律法规。本公司不对第三方平台的接口变动、功能限制、审核处理、处罚决定、服务中断或数据变化负责。</p>
          <p>3. 您授权本公司在实现您主动选择的服务所必需的范围内，处理您提交、同步、上传或授权访问的店铺、商品、订单、内容、经营数据及其他相关信息。您可依平台提供的功能撤回授权；撤回授权可能导致相关服务无法继续使用。</p>
        </section>

        <section>
          <h2>五、用户数据、内容与个人信息</h2>
          <p>1. 您对自行上传、输入、发布、同步或授权本公司处理的数据、商品信息、图片、文本、商标、素材及其他内容承担全部责任，并保证其来源合法、内容真实、权利完整，不侵犯任何第三方的合法权益。</p>
          <p>2. 您保留对依法享有权利的用户内容的权利。为提供、维护、改进和保障观星树服务，您授予本公司在服务所必需范围内存储、复制、处理、传输、展示和使用该等内容的非排他、无偿、可撤销授权；该授权在您停止使用服务后，于实现相关服务、履行法定义务及处理争议所必需的合理期限内继续有效。</p>
          <p>3. 本公司将依照适用法律法规和平台公布的隐私政策处理个人信息，并采取合理的技术和管理措施保护信息安全。除法律法规要求、政府主管部门指令、获得您的有效授权或为实现服务所必需外，本公司不会向无关第三方提供您的个人信息。</p>
          <p>4. 您应自行做好重要数据、内容和经营资料的备份。本公司不保证服务中保存的数据永久不丢失，亦不对因您未及时备份造成的损失承担责任，法律另有规定的除外。</p>
        </section>

        <section>
          <h2>六、用户行为规范</h2>
          <p>您不得利用观星树服务从事或协助他人从事下列行为：</p>
          <ol>
            <li>违反法律法规、监管规定、社会公序良俗或第三方平台规则的行为；</li>
            <li>发布、传播、处理违法、虚假、侵权、欺诈、骚扰、诽谤、淫秽、暴力或其他不当内容；</li>
            <li>侵犯他人知识产权、商业秘密、肖像权、名誉权、个人信息权益或其他合法权益；</li>
            <li>绕过、破坏、干扰平台安全措施，进行爬虫、攻击、逆向工程、非法获取数据或超出授权范围调用服务；</li>
            <li>利用自动化工具实施刷单、虚假交易、恶意营销、规避平台规则或其他不正当经营行为；</li>
            <li>将服务用于违法违规目的，或以任何方式损害本公司、其他用户或第三方的合法权益。</li>
          </ol>
        </section>

        <section>
          <h2>七、费用、结算与退款</h2>
          <p>1. 部分服务可能收费。您使用收费服务前，应阅读并同意对应订购页面、价格说明、订单或补充协议，并按约定及时支付全部费用。</p>
          <p>2. 除法律法规另有规定、双方另有书面约定或本公司存在过错外，已支付的服务费用不予退还。因您的原因未使用、提前停止使用或未达到预期经营效果的，不构成退款依据。</p>
          <p>3. 您逾期付款的，本公司有权暂停、限制或终止相关服务，并依法追究违约责任。若收费规则发生调整，本公司将按适用法律法规和合理方式进行公示或通知，调整后的规则仅适用于其生效后新发生的服务或双方另有约定的情形。</p>
        </section>

        <section>
          <h2>八、知识产权</h2>
          <p>1. 观星树服务中包含的软件、界面、标识、商标、内容、技术、算法、文档及其他相关知识产权，除依法属于您或第三方的内容外，均归本公司或相关权利人所有。</p>
          <p>2. 在本协议约定范围内，本公司授予您一项不可转让、不可再许可、非排他、有限且可撤销的使用许可。未经本公司书面许可，您不得复制、修改、出租、出售、传播、抓取、镜像、反向工程或以其他方式使用上述内容。</p>
          <p>3. 您使用 AI 生成内容时，应自行核验其合法性、准确性、适用性及是否侵害第三方权益；因您使用、发布或商业化该等内容引发的争议、投诉、索赔或处罚，由您自行处理并承担责任。</p>
        </section>

        <section>
          <h2>九、服务中断、风险与免责</h2>
          <p>1. 本公司会尽合理努力保障服务稳定，但受网络、设备、系统维护、第三方服务、不可抗力、监管要求及其他客观因素影响，服务可能出现延迟、中断、故障、数据传输异常或无法使用。本公司将在合理范围内及时修复或处理。</p>
          <p>2. 在法律允许的最大范围内，本公司不对因前述情形、第三方平台原因、用户自身操作、用户内容、经营决策或用户违反本协议造成的间接损失、预期收益损失、商誉损失或数据损失承担责任。</p>
          <p>3. 因地震、台风、洪水、火灾、战争、政府行为、重大公共卫生事件、网络攻击、通信故障等不可抗力导致不能或延迟履行义务的，受影响一方在合理范围内免于承担责任，但应尽力减少损失并及时通知对方。</p>
        </section>

        <section>
          <h2>十、违约处理与赔偿</h2>
          <p>1. 如本公司有合理理由认为您违反本协议、法律法规或第三方平台规则，本公司有权视情况采取提醒、要求整改、删除或屏蔽内容、限制功能、暂停服务、终止服务、关闭账号及向有关部门报告等措施。</p>
          <p>2. 因您违反本协议或违法违规使用服务，导致本公司、其他用户或第三方遭受投诉、索赔、行政处罚、调查、诉讼或损失的，您应负责处理并赔偿本公司因此遭受的全部损失，包括合理的律师费、调查费、差旅费和维权费用。</p>
          <p>3. 除法律法规明确规定外，本公司因违反本协议向您承担的赔偿责任，以导致该等责任的最近十二个月内您就相关服务实际支付的费用总额为上限。</p>
        </section>

        <section>
          <h2>十一、通知与协议更新</h2>
          <p>1. 本公司可通过平台公告、站内信、弹窗、短信、电子邮件、页面提示或您预留的其他联系方式向您发送通知。通知一经发出，即视为已送达；以公告方式作出的通知，自公告载明的日期起视为送达。</p>
          <p>2. 因法律法规、监管政策、业务发展或服务优化需要，本公司可修订本协议，并以合理方式向您公示或通知。修订内容生效后，您继续使用服务的，视为已接受修订后的协议；如您不同意，应在生效前停止使用相关服务。</p>
        </section>

        <section>
          <h2>十二、法律适用与争议解决</h2>
          <p>本协议的订立、生效、履行、解释及争议解决均适用中华人民共和国法律。因本协议或使用观星树服务产生的任何争议，双方应先友好协商；协商不成的，任一方均有权向本公司经营地址所在地有管辖权的人民法院提起诉讼，即浙江省杭州市滨江区有管辖权的人民法院。</p>
        </section>

        <section>
          <h2>十三、其他</h2>
          <p>1. 本协议任一条款被认定为无效、不可执行或部分无效的，不影响其他条款的效力。</p>
          <p>2. 本协议标题仅为阅读便利而设，不影响条款含义或解释。未尽事宜，双方可另行协商；补充协议与本协议具有同等法律效力。</p>
        </section>

        <footer class="gx-agreement__contact">
          <h2>运营方与联系方式</h2>
          <dl>
            <div><dt>运营方</dt><dd>星观（杭州）数据科技有限公司</dd></div>
            <div><dt>联系电话</dt><dd><a href="tel:15824489911">15824489911</a></dd></div>
            <div><dt>联系邮箱</dt><dd><a href="mailto:15824489911@163.com">15824489911@163.com</a></dd></div>
            <div><dt>经营地址</dt><dd>浙江省杭州市滨江区长河街道滨兴路1912号12楼1206室</dd></div>
          </dl>
        </footer>
      </article>
    </main>
  </div>
</template>

<script>
import StarsCanvas from '../../components/newUi/StarsCanvas.vue'
import FloatPts from '../../components/newUi/FloatPts.vue'
import NewUiNav from '../../components/newUi/NewUiNav.vue'

export default {
  name: 'UserAgreementPage',
  components: { StarsCanvas, FloatPts, NewUiNav },
  metaInfo: {
    title: '观星树用户协议'
  },
  mounted() {
    document.title = '观星树用户协议'
  },
  computed: {
    isLoggedIn() {
      return !!this.$store.state.login.token
    }
  },
  methods: {
    goHome() { this.$router.push('/') },
    goLogin() { this.$router.push('/login') },
    goRegister() { this.$router.push('/register') },
    goEnter() {
      if (this.isLoggedIn) this.$router.push('/ucenter?menuId=113')
      else this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.gx-agreement {
  --gx-agreement-bg: #0d1630;
  --gx-agreement-text: #e8e4f0;
  --gx-agreement-muted: #a8b0c6;
  --gx-agreement-accent: #d4a946;
  min-height: 100vh;
  overflow-x: hidden;
  position: relative;
  color: var(--gx-agreement-text);
  background: linear-gradient(160deg, #071027 0%, #0d1630 42%, #17264d 100%);
  font-family: 'Noto Sans SC', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}
.gx-agreement__orb { position: fixed; width: 520px; height: 520px; border-radius: 50%; pointer-events: none; filter: blur(8px); opacity: .16; }
.gx-agreement__orb--left { top: 8%; left: -260px; background: radial-gradient(circle, #d4a946 0%, transparent 68%); }
.gx-agreement__orb--right { right: -260px; bottom: 8%; background: radial-gradient(circle, #3265c4 0%, transparent 68%); }
.gx-agreement__content { width: min(960px, calc(100% - 40px)); margin: 0 auto; padding: 136px 0 72px; position: relative; z-index: 2; }
.gx-agreement__hero { text-align: center; padding: 28px 20px 42px; }
.gx-agreement__eyebrow { color: var(--gx-agreement-accent); font-size: 12px; font-weight: 700; letter-spacing: .2em; }
.gx-agreement__hero h1 { margin: 16px 0 14px; color: #f5f0e5; font-family: 'Noto Serif SC', serif; font-size: clamp(30px, 5vw, 44px); letter-spacing: .08em; }
.gx-agreement__hero p { margin: 0; color: var(--gx-agreement-muted); font-size: 15px; line-height: 1.8; }
.gx-agreement__meta { display: flex; justify-content: center; flex-wrap: wrap; gap: 10px 28px; margin-top: 20px; color: rgba(212, 169, 70, .82); font-family: Inter, monospace; font-size: 12px; }
.gx-agreement__paper { box-sizing: border-box; padding: clamp(28px, 5vw, 58px); border: 1px solid rgba(212, 169, 70, .25); border-radius: 22px; background: rgba(11, 20, 45, .78); box-shadow: 0 24px 70px rgba(0, 0, 0, .34), inset 0 1px rgba(255, 255, 255, .08); backdrop-filter: blur(18px); -webkit-backdrop-filter: blur(18px); }
.gx-agreement__paper section + section { margin-top: 36px; }
.gx-agreement__paper h2 { margin: 0 0 14px; color: #f0d68b; font-family: 'Noto Serif SC', serif; font-size: 20px; line-height: 1.5; }
.gx-agreement__paper p, .gx-agreement__paper li { margin: 0 0 11px; color: #d8d5e2; font-size: 15px; line-height: 2; text-align: justify; }
.gx-agreement__paper ol { margin: 0; padding-left: 24px; }
.gx-agreement__notice { padding: 20px 22px; border-left: 3px solid var(--gx-agreement-accent); border-radius: 0 12px 12px 0; background: rgba(212, 169, 70, .08); }
.gx-agreement__notice h2 { color: #f5df9a; }
.gx-agreement__notice p:last-child, .gx-agreement__paper p:last-child, .gx-agreement__paper li:last-child { margin-bottom: 0; }
.gx-agreement__contact { margin-top: 46px; padding-top: 30px; border-top: 1px solid rgba(212, 169, 70, .22); }
.gx-agreement__contact dl { margin: 0; display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px 32px; }
.gx-agreement__contact dl div { min-width: 0; }
.gx-agreement__contact dt { color: var(--gx-agreement-muted); font-size: 13px; }
.gx-agreement__contact dd { margin: 5px 0 0; color: #f0ebe0; font-size: 14px; line-height: 1.7; word-break: break-all; }
.gx-agreement__contact a { color: #f0d68b; text-decoration: none; }
.gx-agreement__contact a:hover { text-decoration: underline; }
@media (max-width: 700px) {
  .gx-agreement__content { width: min(100% - 24px, 960px); padding-top: 98px; padding-bottom: 36px; }
  .gx-agreement__hero { padding: 20px 8px 30px; }
  .gx-agreement__hero p { font-size: 14px; }
  .gx-agreement__paper { padding: 26px 20px; border-radius: 16px; }
  .gx-agreement__paper section + section { margin-top: 30px; }
  .gx-agreement__paper p, .gx-agreement__paper li { font-size: 14px; line-height: 1.9; }
  .gx-agreement__contact dl { grid-template-columns: 1fr; gap: 14px; }
}
</style>
